import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { CTAButton } from '@/components/_promo/components/CTAButton';
import { DashedCopyCode } from '@/components/_promo/components/DashedCopyCode';
import { WinInfo } from '../WinInfo';
import {
  ScClaimBonusButton,
  ScOfferButtonGroup,
  ScOfferTerms,
  ScPromoCode,
} from './styled';

interface IThirdStageOfferProps {
  fsCount: number;
  promoCode: string;
  onShowTerms: () => void;
  translation: string;
}

export const ThirdStageOffer = ({
  fsCount,
  promoCode,
  onShowTerms,
  translation,
}: IThirdStageOfferProps) => {
  const { t, i18n } = useTranslation(translation);
  const [copyActive, setCopyActive] = useState(false);

  return (
    <>
      <WinInfo
        amount={t('fs', { fsCount })}
        className={i18n.language}
        title={t('youWonReward')}
      />
      <ScPromoCode>
        <DashedCopyCode
          borderStyle="dashed"
          code={promoCode}
          copyActive={copyActive}
          setCopyActive={setCopyActive}
        />
      </ScPromoCode>
      <ScOfferButtonGroup>
        <ScClaimBonusButton>
          <CTAButton
            background="#ea5b0c"
            borderRadius="999px"
            color="#fff"
            text={t('stage3.cta')}
          />
        </ScClaimBonusButton>
        <ScOfferTerms onClick={onShowTerms} type="button">
          {t('termsTitle')}
        </ScOfferTerms>
      </ScOfferButtonGroup>
    </>
  );
};
